module.exports = __webpack_public_path__ + "static/microsoft_logo-ca704e8a2771bf48a9ecba8ee1a170c5.png";